const { makeStyles } = require("@material-ui/core");

export const useStyles = makeStyles((theme) => ({
  row: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    minWidth: 0,
  },
  locationWrapper: {
    backgroundColor: "#fff",
    borderRadius: 5,
    width: 220,
    minWidth: 220,
    maxWidth: 220,
    flex: "0 0 220px",
  },
  infoText: {
    ...theme.typography.body2,
    fontStyle: "italic",
  },
}));
